module.exports = __webpack_public_path__ + "static/media/magedu.37d3b5d2.jpeg";